import './style.less';

export default function($log, $stateParams, AuthClass, HelperClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;
  vm.year = new Date().getFullYear();
  vm.formData = {};

  vm.$stateParams = $stateParams;

  function errorMessage(message) {
    vm.error = message;
    $log.error(message);
    throw new Error(message);
  }

  vm.signup = function() {
    vm.error = false;

    if (!vm.formData.email || !HelperClass.validateEmail(vm.formData.email))
      return errorMessage('Invalid email address.');
    if (!vm.password) return errorMessage('Invalid password.');

    AuthClass.signup(vm.formData.email, vm.password, $stateParams.company_id, function(error, response) {
      if (error || !response || !response.email) return errorMessage('The user already exists.');

      login(response.email, vm.password);
    });
  };

  function login(email, password) {
    AuthClass.login(email, password, function(err) {
      if (err) {
        vm.message = true;
        throw err;
      }
    });
  }

  function activate() {
    $log.debug('User Sign Up Page Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/signUp/index.js